// Application-wide constants for colors, styling, and configuration

export const Constants = {
  colors: {
    // Primary brand colors
    primary: '#475a46',
    secondary: '#324d2c',
    accent: '#b8bab5',
    
    // Background colors
    background: 'var(--background-color)',
    backgroundLight: 'var(--median-window-color)',
    buttonColor: '#b8bab5',
    buttonGreen: '#748a37',
    
    // Mobile-specific colors
    mobileBackground: '#475a46',
    mobileSecondary: '#324d2c',
    
    // UI colors
    white: '#ffffff',
    black: '#000000',
    green: '#466f35',
    lightGrey: '#f8f9fa',
    altLightGrey: '#b8bab5',
    selectedLightGrey: '#d5d8d8',
    darkerGrey: '#989c9b',
    border: '#ddd',
    text: '#193125',
    
    // Status colors
    success: '#28a745',
    error: '#dc3545',
    warning: '#ffc107',
    info: '#17a2b8',
  },
  
  spacing: {
    xs: '5px',
    sm: '10px',
    md: '15px',
    lg: '20px',
    xl: '25px',
    xxl: '30px',
  },
  
  borderRadius: {
    none: '0px',
    small: '5px',
    medium: '10px',
    large: '15px',
    xl: '20px',
    xxl: '35px',
  },
  
  fontSize: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '24px',
    xxl: '28px',
    xxxl: '32px',
  },
  
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1200px',
  },
  
  zIndex: {
    modal: 1000,
    overlay: 999,
    header: 100,
    tabBar: 1000,
  },
  
  dimensions: {
    headerHeight: '120px',
    tabBarHeight: '135px',
    buttonHeight: '50px',
    inputHeight: '50px',
  },
  
  urls: {
    website: 'https://www.mylandscapedesign.com',
    pricing: 'https://www.mylandscapedesign.com/pricing-plans',
    subscriptions: 'https://www.mylandscapedesign.com/my-subscriptions',
  },
  
  // Component-specific constants
  components: {
    tabBar: {
      buttonStyle: {
        root: {
          height: '100%',
          minHeight: '60px',
          padding: '0px',
          fontSize: '12px',
          width: '100%',
          backgroundColor: '#ffffff',
          border: '1px solid #ddd',
          borderRadius: '0px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0px',
        },
      },
      textStyle: {
        whiteSpace: 'normal',
        textAlign: 'center',
        width: '100%',
        display: 'inline-block',
        color: '#475a46',
        fontSize: '24px',
        fontWeight: 'bold',
      },
    },
    
    modal: {
      mobileStyle: {
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 1000,
        },
        content: {
          position: 'fixed',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: '400px',
          height: 'auto',
          maxHeight: '80vh',
          border: 'none',
          borderRadius: '15px',
          padding: '0',
          backgroundColor: 'transparent',
          overflow: 'hidden',
        },
      },
      freeTrialModal: {
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 1000,
        },
        content: {
          position: 'fixed',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          transform: 'translate(-50%, -50%)',
          height: 'auto',
          maxHeight: '80vh',
          border: 'none',
          borderRadius: '15px',
          padding: '0',
          backgroundColor: 'transparent',
          overflow: 'hidden',
          width: '90%',
          maxWidth: '500px',
        }
      },
    },
  },
};

// Export individual constants for easier access
export const {
  colors,
  spacing,
  borderRadius,
  fontSize,
  breakpoints,
  zIndex,
  dimensions,
  urls,
  components,
} = Constants;

// Export specific commonly used values
export const {
  primary,
  secondary,
  mobileBackground,
  mobileSecondary,
  white,
  lightGrey,
  border,
  text,
} = colors;
